let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("be4Ow")).then(() => parcelRequire('9jf84'));